import React from "react";
import { connect } from "react-redux";
import { NavItem } from "reactstrap";
import { push } from 'connected-react-router'

import { createMap } from "../store/Map";

class NewMapButton extends React.Component {
    componentDidUpdate(prevProps) {
        if (this.props.mapId !== prevProps.mapId) {
            this.props.push(`/maps/${this.props.mapId}`);
        }
    }

    newMap = (e) => {
        e.preventDefault();
        this.props.createMap();
    }

    render() {
        return (
            <NavItem>
                <button onClick={this.newMap} className="text-dark btn btn-link">Create new map</button>
            </NavItem>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        mapId: /*ownProps.match.params.id ? Number(ownProps.match.params.id) : */state.map.id
    };
}

const mapDispatchToProps = {
    createMap,
    push: push
};

export default connect(mapStateToProps, mapDispatchToProps)(NewMapButton);
